'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  state: {
    dateRanges: {
      default: {
        from: moment().subtract(29, "days").format("YYYY-MM-DD"),
        to: null,
        date_field: null
      }
    },
    user: null,
    account: null,
    apiToken: null
  },
  mutations: {
    pushDateRange: function pushDateRange(state, dateRange) {
      var dateField = dateRange.date_field || 'default';
      state.dateRanges[dateField] = {
        from: dateRange.from,
        to: dateRange.to,
        date_field: dateField == 'default' ? null : dateField
      };
    },
    setAPIToken: function setAPIToken(state, token) {
      state.apiToken = token;
    },
    setUser: function setUser(state, userData) {
      state.apiToken = userData.token;
      delete userData['token'];
      var currentAccount = localStorage.getItem('currentAccount');
      if (currentAccount != userData.current_account.id) {
        localStorage.setItem('currentAccount', userData.current_account.id);
      }
      state.user = userData;
      state.account = userData.current_account;
    },
    unsetUser: function unsetUser(state) {
      clearInterval(state.userPollingTimer);
      localStorage.removeItem('currentAccount');
      state.apiToken = null;
      state.user = null;
      state.account = null;
    }
  },
  actions: {
    login: function login(context, credentials) {
      return new _promise2.default(function (resolve, reject) {
        context.commit('unsetUser');
        API.user.login(credentials.email, credentials.password).then(function (res) {
          context.commit('setAPIToken', res.data.key);
          resolve();
        }, reject);
      });
    },
    logout: function logout(context) {
      return new _promise2.default(function (resolve, reject) {
        API.user.logout().then(function () {
          context.commit('unsetUser');
          resolve();
        }, function () {
          reject();
        });
      });
    },
    switchAccount: function switchAccount(context, account) {
      return new _promise2.default(function (resolve, reject) {
        API.user.switchAccount(account).then(function (res) {
          context.commit('setUser', res.data);
          _vue2.default.router.push({ path: '/' });
          resolve();
        }, function () {
          reject();
        });
      });
    },
    userReady: function userReady(context) {
      return new _promise2.default(function (resolve, reject) {
        if (context.state.user) {
          resolve();
        }
        var refreshNeeded = false;
        API.user.me().then(function (res) {
          window.addEventListener('visibilitychange', function () {
            if (!document.hidden && refreshNeeded) {
              window.location.reload();
            }
          });
          window.addEventListener('storage', function (ev) {
            if (ev.key == 'currentAccount') {
              if (!document.hidden) {
                window.location.reload();
              } else {
                refreshNeeded = true;
              }
            }
          });
          context.commit('setUser', res.data);
          resolve();
        }, function () {
          context.commit('unsetUser');
          reject();
        });
      });
    }
  },
  getters: {
    getDateRangeByField: function getDateRangeByField(state) {
      return function (field) {
        var dateField = field || 'default';
        return state.dateRanges[dateField] || { from: moment().subtract(29, "days").format("YYYY-MM-DD"), to: null, date_field: field };
      };
    },
    accountIsVendor: function accountIsVendor(state) {
      return state.account.account_type == 'vendor';
    },
    accountIsCustomer: function accountIsCustomer(state) {
      return state.account.account_type == 'customer';
    },
    userIsAdmin: function userIsAdmin(state) {
      return state.user.role == 'superuser';
    },
    userIsSalesAgent: function userIsSalesAgent(state) {
      return state.user.role == 'sales_agent';
    }
  }
});

exports.default = store;


//////////////////
// WEBPACK FOOTER
// ./src/store/index.js
// module id = 80
// module chunks = 0